export const expandedCellStyles = {
  className: "p-0 w-full",
  sx: {
    position: "relative",
    "& > *": { width: "100%" },
  },
}

export const BASE_SORTING_TABLE_FEATURE_PROPS = {
  table: {
    stickyHeader: true,
  },
  tanstackOptions: {
    manualSorting: true,
    enableSorting: true,
    enableMultiSort: false,
    enableSortingRemoval: false,
  },
}
